import classNames from "classnames";
import InputWrapper from "./InputWrapper";

const Textarea = ({
                      name,
                      required = false,
                      label,
                      formik,
                      handleBlur,
                      handleChange,
                      value,
                      error,
                      description,
                      inputWrapperClassName,
                      layout,
                      rows = 3,
                      ...rest
                  }) => {

    const onChange = (e) => {
        if (typeof handleChange === 'function') {
            handleChange(e);
            return
        }

        formik?.handleChange(e);
    }

    const onBlur = (e) => {
        if (typeof handleBlur === 'function') {
            handleBlur(e);
            return
        }

        formik?.handleBlur(e);
    }

    const fieldError = error || (formik?.touched[name] && formik?.errors[name]);
    const fieldValue = formik ? formik.values[name] : value;

    return (
        <InputWrapper
            formik={formik}
            error={error}
            description={description}
            inputWrapperClassName={inputWrapperClassName}
            layout={layout}
            label={label}
            name={name}
            required={required}
        >
            <textarea
                {...rest}
                id={name}
                name={name}
                rows={rows}
                onChange={onChange}
                onBlur={onBlur}
                value={fieldValue ?? ""}
                className={classNames('input', 'textarea', {'has-error': fieldError})}
            />
        </InputWrapper>
    )
}

export default Textarea;
